import { isAxiosError } from 'axios'
import {
  REWRITE_GATE_UNAVAILABLE_ERROR_CODE,
  REWRITE_INSUFFICIENT_SOURCES_ERROR_CODE,
  REWRITE_INSTRUCTION_REFUSED_ERROR_CODE,
  REWRITE_INVALID_OUTPUT_ERROR_CODE,
} from '@artem-lex/compliance-documents'

export type RewriteErrorAction =
  | { type: 'insufficient-sources-dialog' }
  | { type: 'instruction-refused-dialog' }
  | { type: 'retry-toast' }
  | { type: 'rethrow' }

function readRewriteErrorCode(error: unknown): string | null {
  if (
    !isAxiosError(error) ||
    error.response?.status !== 400 ||
    typeof error.response.data !== 'object' ||
    error.response.data == null ||
    !('code' in error.response.data)
  ) {
    return null
  }
  const code = (error.response.data as { code?: unknown }).code
  return typeof code === 'string' ? code : null
}

export function resolveRewriteApiErrorAction(error: unknown): RewriteErrorAction {
  const code = readRewriteErrorCode(error)
  if (code == null) {
    return { type: 'rethrow' }
  }
  if (code === REWRITE_INSUFFICIENT_SOURCES_ERROR_CODE) {
    return { type: 'insufficient-sources-dialog' }
  }
  if (code === REWRITE_INSTRUCTION_REFUSED_ERROR_CODE) {
    return { type: 'instruction-refused-dialog' }
  }
  if (
    code === REWRITE_INVALID_OUTPUT_ERROR_CODE ||
    code === REWRITE_GATE_UNAVAILABLE_ERROR_CODE
  ) {
    return { type: 'retry-toast' }
  }
  return { type: 'rethrow' }
}
